export default {
  // see https://vuetifyjs.com/en/features/theme/#customizing
  /*
  dark: false,
  themes: {
    light: {
      primary: '#41B883'
    },
    dark: {
      primary: '#34495E'
    }
  } */
}
